import { createContext } from 'react';

/**
 * Where an account page's breadcrumb trail and action buttons land inside the
 * app header bar. AccountShell owns the bar and hands these slots down; a page
 * declares what it needs through <AccountBar> and the content is portalled in,
 * so it stays a normal child of the page (state, closures and handlers intact).
 */
export interface AccountHeaderSlots {
  crumbs: HTMLElement | null;
  actions: HTMLElement | null;
  /** A page calls this while mounted so the shell shows the bar (and hides it when no page needs one). */
  registerBar: () => () => void;
}

export const AccountHeaderSlotsContext = createContext<AccountHeaderSlots | null>(null);
